const lcMsTicChemstationJcamp = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (1.8.0)
##DATA TYPE=MASS TIC
##DATA CLASS=XYPOINTS
##ORIGIN=
##OWNER=
##XUNITS=MINUTES
##YUNITS=Intensity
##FIRSTX=1.1228166666666666
##LASTX=13.982933333333333
##MINX=1.1228166666666666
##MAXX=13.982933333333333
##MINY=477198.0
##MAXY=4132871.0
##NPOINTS=824
##FIRSTY=3027291.0
##XUNITS=MINUTES
##YUNITS=Intensity
##XYDATA=(XY..XY)
1.1228166666666666, 3027291.0
1.1384333333333334, 2614443.0
1.1540666666666666, 2082582.0
1.1696833333333334, 1742539.0
1.1853166666666666, 1478134.0
1.2009333333333334, 1230975.0
1.2165666666666666, 990282.0
1.2321833333333334, 785095.0
1.2478166666666666, 644776.0
1.26345, 557032.0
1.2790666666666666, 512268.0
1.2947, 528879.0
1.3103166666666666, 589122.0
1.32595, 658357.0
1.3415666666666666, 728136.0
1.3572, 838817.0
1.3728166666666666, 1021997.0
1.38845, 1209182.0
1.4040833333333333, 1341838.0
1.4197, 1379396.0
1.4353333333333333, 1335289.0
1.45095, 1232215.0
1.4665833333333333, 1085246.0
1.4822, 914457.0
1.4978333333333333, 787833.0
1.51345, 701870.0
1.5290833333333333, 663660.0
1.5447166666666667, 651376.0
1.5603333333333333, 634980.0
1.5759666666666667, 611165.0
1.5915833333333333, 575253.0
1.6072166666666667, 545924.0
1.6228333333333333, 541170.0
1.6384666666666667, 537490.0
1.6540833333333333, 545300.0
1.6697166666666667, 570381.0
1.68535, 597520.0
1.7009666666666667, 630019.0
1.7166, 697538.0
1.7322166666666667, 779904.0
1.74785, 862025.0
1.7634666666666667, 892511.0
1.7791, 864337.0
1.7947166666666667, 781954.0
1.81035, 682217.0
1.8259833333333333, 592779.0
1.8416, 536641.0
1.8572333333333333, 512153.0
1.87285, 506504.0
1.8884833333333333, 504130.0
1.9041, 504854.0
1.9197333333333333, 495848.0
1.93535, 488605.0
1.9509833333333333, 483000.0
1.9666166666666667, 480113.0
1.9822333333333333, 479653.0
1.9978666666666667, 477198.0
2.0134833333333333, 485124.0
2.0291166666666665, 501710.0
2.0447333333333333, 530744.0
2.0603666666666665, 544189.0
2.0759833333333333, 546513.0
2.0916166666666665, 537257.0
2.10725, 521294.0
2.1228666666666665, 513657.0
2.1385, 507896.0
2.1541166666666665, 508118.0
2.16975, 500653.0
2.1853666666666665, 492561.0
2.201, 488516.0
2.2166166666666665, 486260.0
2.23225, 480984.0
2.2478833333333332, 567749.0
2.2635, 1094638.0
2.2791333333333332, 2121084.0
2.29475, 3250745.0
2.3103833333333332, 3977718.0
2.326, 4132871.0
2.3416333333333332, 3977565.0
2.35725, 3822055.0
2.3728833333333332, 3695496.0
2.388516666666667, 3577773.0
2.4041333333333332, 3505302.0
2.419766666666667, 3536560.0
2.4353833333333332, 3620983.0
2.451016666666667, 3730384.0
2.4666333333333332, 3778269.0
2.482266666666667, 3779607.0
2.4978833333333332, 3699801.0
2.513516666666667, 3563842.0
2.52915, 3387448.0
2.544766666666667, 3265793.0
2.5604, 3230421.0
2.576016666666667, 3252470.0
2.59165, 3261668.0
2.607266666666667, 3221924.0
2.6229, 3153837.0
2.638516666666667, 3083530.0
2.65415, 2987816.0
2.669783333333333, 2921710.0
2.6854, 2893382.0
2.701033333333333, 2881821.0
2.71665, 2851241.0
2.732283333333333, 2805834.0
2.7479, 2781692.0
2.763533333333333, 2791255.0
2.77915, 2781220.0
2.794783333333333, 2709204.0
2.810416666666667, 2612720.0
2.826033333333333, 2528109.0
2.841666666666667, 2511209.0
2.857283333333333, 2520025.0
2.872916666666667, 2535926.0
2.888533333333333, 2508578.0
2.904166666666667, 2461555.0
2.919783333333333, 2422748.0
2.935416666666667, 2425836.0
2.95105, 2418145.0
2.966666666666667, 2405712.0
2.9823, 2374387.0
2.997916666666667, 2365666.0
3.01355, 2345078.0
3.029166666666667, 2311669.0
3.0448, 2238755.0
3.060416666666667, 2167696.0
3.07605, 2109982.0
3.091683333333333, 2091036.0
3.1073, 2082461.0
3.122933333333333, 2063997.0
3.13855, 2069826.0
3.154183333333333, 2029586.0
3.1698, 1981975.0
3.185433333333333, 1906529.0
3.20105, 1860407.0
3.216683333333333, 1834368.0
3.2323166666666667, 1834444.0
3.247933333333333, 1821507.0
3.2635666666666667, 1811418.0
3.279183333333333, 1781011.0
3.2948166666666667, 1729245.0
3.310433333333333, 1679472.0
3.3260666666666667, 1666131.0
3.341683333333333, 1679344.0
3.3573166666666667, 1715558.0
3.372933333333333, 1727502.0
3.3885666666666667, 1726321.0
3.4042, 1708895.0
3.4198166666666667, 1682731.0
3.43545, 1632539.0
3.4510666666666667, 1578627.0
3.4667, 1536472.0
3.4823166666666667, 1531451.0
3.49795, 1544597.0
3.5135833333333335, 1543167.0
3.5292, 1523978.0
3.5448333333333335, 1500362.0
3.56045, 1507339.0
3.5760833333333335, 1519666.0
3.5917, 1525841.0
3.6073333333333335, 1546951.0
3.62295, 1505702.0
3.6385833333333335, 1474489.0
3.6542, 1446277.0
3.6698333333333335, 1407618.0
3.6854666666666667, 1381116.0
3.7010833333333335, 1363704.0
3.7167166666666667, 1333686.0
3.7323333333333335, 1293671.0
3.7479666666666667, 1254680.0
3.7635833333333335, 1225866.0
3.7792166666666667, 1217591.0
3.7948333333333335, 1216820.0
3.8104666666666667, 1201668.0
3.8261, 1182382.0
3.8417166666666667, 1192744.0
3.85735, 1189250.0
3.8729666666666667, 1151714.0
3.8886, 1118104.0
3.9042166666666667, 1080910.0
3.91985, 1044189.0
3.9354666666666667, 1038374.0
3.9511, 1019469.0
3.9667333333333334, 1000380.0
3.98235, 987682.0
3.9979833333333334, 962935.0
4.0136, 934536.0
4.029233333333333, 911706.0
4.04485, 877584.0
4.060483333333333, 849361.0
4.0761, 833012.0
4.091733333333333, 822915.0
4.107366666666667, 796870.0
4.122983333333333, 759443.0
4.138616666666667, 716767.0
4.154233333333333, 690625.0
4.169866666666667, 672528.0
4.185483333333333, 653928.0
4.201116666666667, 632407.0
4.216733333333333, 598961.0
4.232366666666667, 567746.0
4.248, 549265.0
4.263616666666667, 538651.0
4.27925, 524668.0
4.294866666666667, 509193.0
4.3105, 496929.0
4.326116666666667, 500091.0
4.34175, 501994.0
4.357366666666667, 514138.0
4.373, 514169.0
4.388633333333333, 515864.0
4.40425, 503415.0
4.419883333333333, 492056.0
4.4355, 487509.0
4.451133333333333, 484782.0
4.46675, 488834.0
4.482383333333333, 499331.0
4.498, 503866.0
4.513633333333333, 495993.0
4.5292666666666666, 482388.0
4.544883333333333, 478108.0
4.5605166666666666, 482133.0
4.576133333333333, 496253.0
4.5917666666666666, 497054.0
4.607383333333333, 507124.0
4.6230166666666666, 514423.0
4.638633333333333, 520555.0
4.6542666666666666, 516793.0
4.6699, 521496.0
4.6855166666666666, 524679.0
4.70115, 525565.0
4.7167666666666666, 522776.0
4.7324, 526169.0
4.7480166666666666, 523587.0
4.76365, 522761.0
4.7792666666666666, 526616.0
4.7949, 533056.0
4.810533333333334, 537231.0
4.82615, 542475.0
4.841783333333334, 545512.0
4.8574, 549356.0
4.873033333333334, 545543.0
4.88865, 547490.0
4.904283333333334, 539361.0
4.9199, 536606.0
4.935533333333334, 534892.0
4.9511666666666665, 538026.0
4.966783333333334, 538860.0
4.9824166666666665, 558108.0
4.998033333333334, 571710.0
5.0136666666666665, 579944.0
5.029283333333334, 580532.0
5.0449166666666665, 572076.0
5.060533333333334, 568173.0
5.0761666666666665, 573605.0
5.0918, 586438.0
5.1074166666666665, 592043.0
5.12305, 597088.0
5.1386666666666665, 595058.0
5.1543, 588554.0
5.1699166666666665, 587815.0
5.18555, 590679.0
5.2011666666666665, 594384.0
5.2168, 593084.0
5.232433333333334, 586765.0
5.24805, 572991.0
5.263683333333334, 567962.0
5.2793, 576558.0
5.294933333333334, 598103.0
5.31055, 621708.0
5.326183333333334, 644920.0
5.3418, 666362.0
5.357433333333334, 679629.0
5.373066666666666, 681871.0
5.388683333333334, 676889.0
5.404316666666666, 673815.0
5.419933333333334, 676363.0
5.435566666666666, 672539.0
5.451183333333334, 668464.0
5.466816666666666, 671287.0
5.482433333333334, 674494.0
5.498066666666666, 690529.0
5.5137, 716464.0
5.529316666666666, 732221.0
5.54495, 735378.0
5.560566666666666, 725853.0
5.5762, 722418.0
5.591816666666666, 728436.0
5.60745, 750516.0
5.623066666666666, 774033.0
5.6387, 778783.0
5.654333333333334, 765642.0
5.66995, 767533.0
5.685583333333334, 780458.0
5.7012, 780830.0
5.716833333333334, 790233.0
5.73245, 802003.0
5.748083333333334, 831979.0
5.7637, 874803.0
5.779333333333334, 927209.0
5.794966666666666, 956723.0
5.810583333333334, 947911.0
5.826216666666666, 942123.0
5.841833333333334, 943717.0
5.857466666666666, 959656.0
5.873083333333334, 969905.0
5.888716666666666, 988802.0
5.904333333333334, 987775.0
5.919966666666666, 975049.0
5.9356, 967765.0
5.951216666666666, 988333.0
5.96685, 1018846.0
5.982466666666666, 1036367.0
5.9981, 1051463.0
6.013716666666666, 1054954.0
6.02935, 1071748.0
6.044966666666666, 1137288.0
6.0606, 1216454.0
6.076233333333334, 1262743.0
6.09185, 1262913.0
6.107483333333334, 1222788.0
6.1231, 1212368.0
6.138733333333334, 1224889.0
6.15435, 1267633.0
6.169983333333334, 1315717.0
6.1856, 1360717.0
6.201233333333334, 1395930.0
6.216866666666666, 1399331.0
6.232483333333334, 1401614.0
6.248116666666666, 1419447.0
6.263733333333334, 1424877.0
6.279366666666666, 1442115.0
6.294983333333334, 1440783.0
6.310616666666666, 1448305.0
6.326233333333334, 1462158.0
6.341866666666666, 1496940.0
6.3575, 1533902.0
6.373116666666666, 1549829.0
6.38875, 1556861.0
6.404366666666666, 1573984.0
6.42, 1601610.0
6.435616666666666, 1643414.0
6.45125, 1700486.0
6.466866666666666, 1752432.0
6.4825, 1791523.0
6.4981333333333335, 1805182.0
6.51375, 1809779.0
6.5293833333333335, 1816863.0
6.545, 1838288.0
6.5606333333333335, 1846521.0
6.57625, 1836179.0
6.5918833333333335, 1771701.0
6.6075, 1624129.0
6.6231333333333335, 1411741.0
6.638766666666666, 1194460.0
6.6543833333333335, 1045545.0
6.670016666666666, 963927.0
6.6856333333333335, 936428.0
6.701266666666666, 925647.0
6.7168833333333335, 927296.0
6.732516666666666, 918393.0
6.7481333333333335, 911196.0
6.763766666666666, 918224.0
6.7794, 923920.0
6.795016666666666, 941422.0
6.81065, 949774.0
6.826266666666666, 954326.0
6.8419, 951391.0
6.857516666666666, 953815.0
6.87315, 963994.0
6.888766666666666, 985386.0
6.9044, 993285.0
6.9200333333333335, 988325.0
6.93565, 978162.0
6.9512833333333335, 990768.0
6.9669, 1008097.0
6.9825333333333335, 1022499.0
6.99815, 1025604.0
7.0137833333333335, 1017623.0
7.0294, 1023656.0
7.0450333333333335, 1034942.0
7.060666666666667, 1046617.0
7.0762833333333335, 1047073.0
7.091916666666667, 1052869.0
7.1075333333333335, 1040617.0
7.123166666666667, 1020599.0
7.1387833333333335, 994837.0
7.154416666666667, 988807.0
7.1700333333333335, 996655.0
7.185666666666667, 1016500.0
7.2013, 1022917.0
7.216916666666667, 1006165.0
7.23255, 985740.0
7.248166666666667, 954512.0
7.2638, 928716.0
7.279416666666667, 900485.0
7.29505, 889046.0
7.310666666666667, 885434.0
7.3263, 891300.0
7.341933333333333, 908041.0
7.35755, 942331.0
7.373183333333333, 967922.0
7.3888, 964411.0
7.404433333333333, 950357.0
7.42005, 954155.0
7.435683333333333, 975609.0
7.4513, 982689.0
7.466933333333333, 997918.0
7.482566666666667, 1008056.0
7.498183333333333, 1034309.0
7.513816666666667, 1043518.0
7.529433333333333, 1069215.0
7.545066666666667, 1077456.0
7.560683333333333, 1072581.0
7.576316666666667, 1049690.0
7.591933333333333, 1027512.0
7.607566666666667, 989609.0
7.6232, 963781.0
7.638816666666667, 960949.0
7.65445, 965541.0
7.670066666666667, 965037.0
7.6857, 955544.0
7.701316666666667, 937154.0
7.71695, 934596.0
7.732566666666667, 942224.0
7.7482, 947721.0
7.763833333333333, 947635.0
7.77945, 917692.0
7.795083333333333, 891851.0
7.8107, 877575.0
7.826333333333333, 875091.0
7.84195, 871737.0
7.857583333333333, 856706.0
7.8732, 855489.0
7.888833333333333, 849403.0
7.904466666666667, 871359.0
7.920083333333333, 889146.0
7.935716666666667, 906418.0
7.951333333333333, 919152.0
7.966966666666667, 920090.0
7.982583333333333, 923353.0
7.998216666666667, 920744.0
8.013833333333332, 925997.0
8.029466666666666, 943905.0
8.0451, 955196.0
8.060716666666666, 962580.0
8.07635, 956503.0
8.091966666666666, 965084.0
8.1076, 990140.0
8.123216666666666, 1005665.0
8.13885, 1017590.0
8.154466666666666, 1003428.0
8.1701, 982662.0
8.185716666666666, 980715.0
8.20135, 993517.0
8.216983333333333, 1001491.0
8.2326, 1011077.0
8.248233333333333, 1026441.0
8.26385, 1004456.0
8.279483333333333, 972309.0
8.2951, 965304.0
8.310733333333333, 967268.0
8.326366666666667, 974789.0
8.341983333333333, 979619.0
8.357616666666667, 991311.0
8.373233333333333, 1008523.0
8.388866666666667, 1040266.0
8.404483333333333, 1066292.0
8.420116666666667, 1083339.0
8.435733333333333, 1097821.0
8.451366666666667, 1089432.0
8.466983333333333, 1100057.0
8.482616666666667, 1091442.0
8.49825, 1090298.0
8.513866666666667, 1073300.0
8.5295, 1066597.0
8.545116666666667, 1067119.0
8.56075, 1083095.0
8.576366666666667, 1102409.0
8.592, 1121049.0
8.607616666666667, 1124128.0
8.62325, 1116666.0
8.638883333333334, 1112904.0
8.6545, 1118485.0
8.670133333333334, 1114523.0
8.68575, 1092789.0
8.701383333333334, 1083640.0
8.717, 1081444.0
8.732633333333334, 1103948.0
8.74825, 1127493.0
8.763883333333334, 1127583.0
8.779516666666666, 1116046.0
8.795133333333334, 1106494.0
8.810766666666666, 1108317.0
8.826383333333334, 1107114.0
8.842016666666666, 1111896.0
8.857633333333334, 1113666.0
8.873266666666666, 1125209.0
8.888883333333334, 1141975.0
8.904516666666666, 1147064.0
8.92015, 1126494.0
8.935766666666666, 1100549.0
8.9514, 1058374.0
8.967016666666666, 1026308.0
8.98265, 989858.0
8.998266666666666, 980034.0
9.0139, 987556.0
9.029516666666666, 1001551.0
9.04515, 1016437.0
9.060783333333333, 1017225.0
9.0764, 1018708.0
9.092033333333333, 1000758.0
9.10765, 991149.0
9.123283333333333, 989861.0
9.1389, 1003479.0
9.154533333333333, 1024056.0
9.17015, 1018166.0
9.185783333333333, 1005859.0
9.201416666666667, 997106.0
9.217033333333333, 985671.0
9.232666666666667, 1001174.0
9.248283333333333, 1013208.0
9.263916666666667, 1023296.0
9.279533333333333, 1010283.0
9.295166666666667, 1002577.0
9.310783333333333, 1010931.0
9.326416666666667, 1026435.0
9.34205, 1039343.0
9.357666666666667, 1049742.0
9.3733, 1055874.0
9.388916666666667, 1047890.0
9.40455, 1031519.0
9.420166666666667, 1019506.0
9.4358, 1023747.0
9.451416666666667, 1034092.0
9.46705, 1051490.0
9.482683333333334, 1077113.0
9.4983, 1083682.0
9.513933333333334, 1079585.0
9.52955, 1077114.0
9.545183333333334, 1085600.0
9.5608, 1087000.0
9.576433333333334, 1097770.0
9.59205, 1102507.0
9.607683333333334, 1121903.0
9.623316666666666, 1133405.0
9.638933333333334, 1158856.0
9.654566666666666, 1183132.0
9.670183333333334, 1197059.0
9.685816666666666, 1222880.0
9.701433333333334, 1240759.0
9.717066666666666, 1238938.0
9.732683333333334, 1243679.0
9.748316666666666, 1253000.0
9.76395, 1242141.0
9.779566666666666, 1231530.0
9.7952, 1201482.0
9.810816666666666, 1193362.0
9.82645, 1171899.0
9.842066666666666, 1173737.0
9.8577, 1231696.0
9.873316666666666, 1347797.0
9.88895, 1434291.0
9.904583333333333, 1453707.0
9.9202, 1382447.0
9.935833333333333, 1277469.0
9.95145, 1205125.0
9.967083333333333, 1177083.0
9.9827, 1147086.0
9.998333333333333, 1142023.0
10.01395, 1137902.0
10.029583333333333, 1150956.0
10.045216666666667, 1160440.0
10.060833333333333, 1168620.0
10.076466666666667, 1175778.0
10.092083333333333, 1164629.0
10.107716666666667, 1166742.0
10.123333333333333, 1161222.0
10.138966666666667, 1168422.0
10.154583333333333, 1161706.0
10.170216666666667, 1161649.0
10.18585, 1184723.0
10.201466666666667, 1216269.0
10.2171, 1221462.0
10.232716666666667, 1227623.0
10.24835, 1236992.0
10.263966666666667, 1233642.0
10.2796, 1217614.0
10.295216666666667, 1192735.0
10.31085, 1195094.0
10.326483333333334, 1202836.0
10.3421, 1217982.0
10.357733333333334, 1221286.0
10.37335, 1209344.0
10.388983333333334, 1204461.0
10.4046, 1214838.0
10.420233333333334, 1244749.0
10.43585, 1262135.0
10.451483333333334, 1259837.0
10.467116666666668, 1257168.0
10.482733333333334, 1285594.0
10.498366666666668, 1309470.0
10.513983333333334, 1310691.0
10.529616666666668, 1284270.0
10.545233333333334, 1267569.0
10.560866666666668, 1247449.0
10.576483333333334, 1236448.0
10.592116666666668, 1260667.0
10.60775, 1277927.0
10.623366666666668, 1280237.0
10.639, 1286564.0
10.654616666666668, 1290367.0
10.67025, 1309748.0
10.685866666666668, 1325709.0
10.7015, 1360970.0
10.717116666666668, 1363843.0
10.73275, 1366064.0
10.748383333333333, 1370699.0
10.764, 1385755.0
10.779633333333333, 1385476.0
10.79525, 1373836.0
10.810883333333333, 1364274.0
10.8265, 1368821.0
10.842133333333333, 1389650.0
10.85775, 1403245.0
10.873383333333333, 1424796.0
10.889016666666667, 1444802.0
10.904633333333333, 1468361.0
10.920266666666667, 1472111.0
10.935883333333333, 1463500.0
10.951516666666667, 1494173.0
10.967133333333333, 1505478.0
10.982766666666667, 1520155.0
10.998383333333333, 1541873.0
11.014016666666667, 1548807.0
11.02965, 1515034.0
11.045266666666667, 1501358.0
11.0609, 1522980.0
11.076516666666667, 1550070.0
11.09215, 1573497.0
11.107766666666667, 1556319.0
11.1234, 1524676.0
11.139016666666667, 1499015.0
11.15465, 1499134.0
11.170283333333334, 1526720.0
11.1859, 1577171.0
11.201533333333334, 1611298.0
11.21715, 1651858.0
11.232783333333334, 1681184.0
11.2484, 1732876.0
11.264033333333334, 1803696.0
11.27965, 1870332.0
11.295283333333334, 1905747.0
11.310916666666667, 1926027.0
11.326533333333334, 1982247.0
11.342166666666667, 2037452.0
11.357783333333334, 2078162.0
11.373416666666667, 2085632.0
11.389033333333334, 2038437.0
11.404666666666667, 1972813.0
11.420283333333334, 1879752.0
11.435916666666667, 1818918.0
11.45155, 1791472.0
11.467166666666667, 1768301.0
11.4828, 1768602.0
11.498416666666667, 1766967.0
11.51405, 1752097.0
11.529666666666667, 1765977.0
11.5453, 1766193.0
11.560916666666667, 1780252.0
11.57655, 1810692.0
11.592183333333333, 1850046.0
11.6078, 1885924.0
11.623433333333333, 1933722.0
11.63905, 1973033.0
11.654683333333333, 1977603.0
11.6703, 1965654.0
11.685933333333333, 1926713.0
11.70155, 1951330.0
11.717183333333333, 1976103.0
11.732816666666666, 1975124.0
11.748433333333333, 1956283.0
11.764066666666666, 1923716.0
11.779683333333333, 1911338.0
11.795316666666666, 1929242.0
11.810933333333333, 1937194.0
11.826566666666666, 1919487.0
11.842183333333333, 1892839.0
11.857816666666666, 1872617.0
11.87345, 1882875.0
11.889066666666666, 1914559.0
11.9047, 1950311.0
11.920316666666666, 1987191.0
11.93595, 2038995.0
11.951566666666666, 2074939.0
11.9672, 2096367.0
11.982816666666666, 2120021.0
11.99845, 2173175.0
12.014083333333334, 2226166.0
12.0297, 2244661.0
12.045333333333334, 2227421.0
12.06095, 2223644.0
12.076583333333334, 2250745.0
12.0922, 2300281.0
12.107833333333334, 2329250.0
12.12345, 2346992.0
12.139083333333334, 2383488.0
12.154716666666667, 2417314.0
12.170333333333334, 2409977.0
12.185966666666667, 2412179.0
12.201583333333334, 2432384.0
12.217216666666667, 2472384.0
12.232833333333334, 2497442.0
12.248466666666667, 2474640.0
12.264083333333334, 2427884.0
12.279716666666667, 2404462.0
12.29535, 2393812.0
12.310966666666667, 2402884.0
12.3266, 2401751.0
12.342216666666667, 2386678.0
12.35785, 2377709.0
12.373466666666667, 2380177.0
12.3891, 2391673.0
12.404716666666667, 2403636.0
12.42035, 2382149.0
12.435983333333333, 2349831.0
12.4516, 2317662.0
12.467233333333333, 2317762.0
12.48285, 2330375.0
12.498483333333333, 2330512.0
12.5141, 2303156.0
12.529733333333333, 2250466.0
12.54535, 2191825.0
12.560983333333333, 2151873.0
12.576616666666666, 2100562.0
12.592233333333333, 2056855.0
12.607866666666666, 2012743.0
12.623483333333333, 1971493.0
12.639116666666666, 1929799.0
12.654733333333333, 1883973.0
12.670366666666666, 1870734.0
12.685983333333333, 1876529.0
12.701616666666666, 1846406.0
12.717233333333333, 1777220.0
12.732866666666666, 1723393.0
12.7485, 1633338.0
12.764116666666666, 1562267.0
12.77975, 1502988.0
12.795366666666666, 1492099.0
12.811, 1484227.0
12.826616666666666, 1437610.0
12.84225, 1363211.0
12.857883333333334, 1298260.0
12.8735, 1254197.0
12.889133333333334, 1217986.0
12.90475, 1178466.0
12.920383333333334, 1142491.0
12.936, 1085249.0
12.951633333333334, 1001375.0
12.96725, 950803.0
12.982883333333334, 919882.0
12.9985, 938123.0
13.014133333333334, 934907.0
13.029766666666667, 923386.0
13.045383333333334, 893908.0
13.061016666666667, 859505.0
13.076633333333334, 814843.0
13.092266666666667, 799159.0
13.107883333333334, 794641.0
13.123516666666667, 778985.0
13.139133333333334, 760838.0
13.154766666666667, 754085.0
13.1704, 759556.0
13.186016666666667, 781872.0
13.20165, 794021.0
13.217266666666667, 807286.0
13.2329, 828309.0
13.248516666666667, 840539.0
13.26415, 831314.0
13.279766666666667, 832351.0
13.2954, 852680.0
13.311033333333333, 864758.0
13.32665, 836014.0
13.342283333333333, 837703.0
13.3579, 835722.0
13.373533333333333, 850637.0
13.38915, 867731.0
13.404783333333333, 871385.0
13.4204, 871346.0
13.436033333333333, 851516.0
13.451666666666666, 827519.0
13.467283333333333, 807728.0
13.482916666666666, 792582.0
13.498533333333333, 807405.0
13.514166666666666, 812507.0
13.529783333333333, 811330.0
13.545416666666666, 800018.0
13.561033333333333, 790502.0
13.576666666666666, 787586.0
13.5923, 778954.0
13.607916666666666, 777725.0
13.62355, 780595.0
13.639166666666666, 766303.0
13.6548, 764817.0
13.670416666666666, 768867.0
13.68605, 790443.0
13.701666666666666, 807937.0
13.7173, 813460.0
13.732933333333333, 789825.0
13.74855, 791980.0
13.764183333333333, 775905.0
13.7798, 745178.0
13.795433333333333, 743589.0
13.81105, 738545.0
13.826683333333333, 739223.0
13.8423, 743456.0
13.857933333333333, 738729.0
13.873566666666667, 737741.0
13.889183333333333, 760394.0
13.904816666666667, 778994.0
13.920433333333333, 784934.0
13.936066666666667, 782825.0
13.951683333333333, 772886.0
13.967316666666667, 760939.0
13.982933333333333, 744415.0
##END=$$ End of the data block

`;

export default lcMsTicChemstationJcamp;
